import React, { useEffect, useState } from 'react';
import api from "../services/api";
import BookIndex from "./books/BookIndex";
import Pagination from "./assets/Pagination";

const Home = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const booksPerPage = 9;

    useEffect(() => {
        api.get('/index')
            .then(response => setData(response.data))
            .catch(error => console.error('Error fetching data:', error))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center py-24">
                <div className="text-center">
                    <span className="text-4xl animate-pulse">📖</span>
                    <p className="mt-4 text-warm-400 font-medium">Loading your library…</p>
                </div>
            </div>
        );
    }

    if (!data || !data.books?.length) {
        return (
            <div className="flex items-center justify-center py-24 text-warm-400">
                <p>Your library is empty. Search for a book to get started.</p>
            </div>
        );
    }

    const indexOfLastBook = currentPage * booksPerPage;
    const indexOfFirstBook = indexOfLastBook - booksPerPage;
    const currentBooks = data.books.slice(indexOfFirstBook, indexOfLastBook);

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(data.books.length / booksPerPage); i++) {
        pageNumbers.push(i);
    }

    const handleClick = (event, pageNumber) => {
        event.preventDefault();
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <div className="mb-8 flex items-end justify-between border-b border-warm-200 pb-4">
                <div>
                    <h1 className="font-serif text-3xl font-bold text-warm-800">My Library</h1>
                    <p className="text-warm-400 text-sm mt-1">{data.books.length} book{data.books.length !== 1 ? 's' : ''} in your collection</p>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {currentBooks.map((book) => (
                    <BookIndex key={book.id} book={book} />
                ))}
            </div>

            <Pagination handleClick={handleClick} currentPage={currentPage} pageNumbers={pageNumbers} />
        </>
    );
};

export default Home;
